'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function DragHandler(props) {
		return React.createElement(
				IconBase,
				_extends({ viewBox: '43.5 80 1000 400' }, props),
				React.createElement('path', { d: 'M135.9,177.6c0,26.3,21.3,47.5,47.5,47.5s47.5-21.3,47.5-47.5l0,0c0-26.3-21.3-47.5-47.5-47.5\r S135.9,151.3,135.9,177.6z M376,177.6c0,26.3,21.3,47.6,47.5,47.6c26.3,0,47.6-21.3,47.6-47.5c0,0,0,0,0,0\r c0-26.3-21.3-47.6-47.5-47.6C397.3,130,376,151.3,376,177.6C376,177.5,376,177.5,376,177.6z M616,177.6c0,26.3,21.3,47.6,47.5,47.6\r c26.3,0,47.6-21.3,47.6-47.5c0,0,0,0,0,0c0-26.3-21.3-47.6-47.5-47.6C637.4,130,616.1,151.3,616,177.6\r C616,177.5,616,177.5,616,177.6z M856,177.6c0,26.3,21.3,47.6,47.5,47.6s47.6-21.3,47.6-47.5c0,0,0,0,0,0\r c0-26.3-21.3-47.6-47.5-47.6C877.3,130,856.1,151.3,856,177.6C856,177.5,856,177.5,856,177.6z M135.9,382.4\r c0,26.3,21.3,47.5,47.5,47.5s47.5-21.3,47.5-47.5s-21.3-47.5-47.5-47.5S135.9,356.2,135.9,382.4z M376,382.4\r c0,26.3,21.3,47.6,47.5,47.6c26.3,0,47.6-21.3,47.6-47.5c0,0,0,0,0,0c0-26.3-21.3-47.6-47.5-47.6C397.3,334.9,376,356.1,376,382.4\r C376,382.4,376,382.4,376,382.4z M616,382.4c0,26.3,21.3,47.6,47.5,47.6c26.3,0,47.6-21.3,47.6-47.5c0,0,0,0,0,0\r c0-26.3-21.3-47.6-47.5-47.6C637.4,334.9,616.1,356.1,616,382.4C616,382.4,616,382.4,616,382.4z M856,382.4\r c0,26.3,21.3,47.6,47.5,47.6c26.3,0,47.6-21.3,47.6-47.5c0,0,0,0,0,0c0-26.3-21.3-47.6-47.5-47.6C877.3,334.9,856.1,356.1,856,382.4\r C856,382.4,856,382.4,856,382.4z' })
		);
}
DragHandler.displayName = 'DragHandler';

module.exports = DragHandler;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/drag-handler.js
// module id = 168
// module chunks = 0